export default "__VITE_ASSET__BAI$NyYx__"